.row-spacer {
  display: flex;
  height: 12px;

  .time-col {
    position: relative;
    box-sizing: border-box;
    width: var(--rc-calendar-hour-width);
    border-right: var(--rc-calendar-border-base);
  }

  .week-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    flex: 1;

    > div {
      box-sizing: border-box;
      border-right: var(--rc-calendar-border-base);

      &:last-child {
        border-right: 0;
      }
    }
  }
}
